import React from 'react';
import moment from 'moment';
import I18n from '../../../i18n/I18n';
import Helper from '../../../helper/Helper';
import ReservedBox from '../reservedBox/ReservedBox';
import Title from '../../common/widgetTitle/WidgetTitle';
import styles from '../../products/productTable/ProductTable.scss';

const ReservedItems = (props: Object) => {
  const data = props.data || '';
  const itemsList = data
    ? data.map((item, index) => {
        return (
          <tr valign="center" key={index}>
            <td className={styles.nameWrapper}>
              {item.imagekey
                ? <div className={styles.itemImg}>
                    <img src={Helper.getTransformationUrl(item.imagekey)} alt="placeholder" />
                  </div>
                : ''}
              <div>
                {item.title}
                {item.brand
                  ? <div className={styles.brand}>
                      {item.brand}
                    </div>
                  : ''}
              </div>
            </td>
            <td>
              {item.partner_sku || ''}
            </td>
            <td>
              {item.sku || ''}
            </td>
            <td>
              {item.variant || ''}
            </td>
            <td className={styles.price}>
              {item.offer_price
                ? <div>
                    {I18n.formatCurrency(Helper.formatPrice(item.offer_price, props.currencyCode))}
                  </div>
                : ''}
            </td>
          </tr>
        );
      })
    : '';

  const itemBoxList = data
    ? data.map((item, index) => {
        return (
          <div className={styles.boxWrapper} key={index}>
            <ReservedBox item={item} currencyCode={props.currencyCode} />
          </div>
        );
      })
    : '';
  return (
    <div className={styles.ctr}>
      {props.browser && props.browser.greaterThan.tablet
        ? <table className={styles.table}>
            <thead>
              <tr className={`${styles.row} ${styles.head}`}>
                <th>
                  {I18n.getText('reserved.name', {}, 'Name')}
                </th>
                <th>
                  {I18n.getText('reserved.p-sku', {}, '	Partner SKU')}
                </th>
                <th>
                  {I18n.getText('reserved.sku', {}, 'SKU')}
                </th>
                <th>
                  {I18n.getText('reserved.variant', {}, 'Variant')}
                </th>
                <th>
                  {I18n.getText('reserved.price', {}, 'Price')}
                </th>
              </tr>
            </thead>
            <tbody>
              {itemsList}
            </tbody>
          </table>
        : itemBoxList}
    </div>
  );
};

export default ReservedItems;



// WEBPACK FOOTER //
// ./src/components/orders/reservedItems/ReservedItems.js